/*
 * @Autor: xx
 * @Version: 1.0
 * @Date: 2020-05-29 11:27:25
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2020-10-21 09:48:06
 */

// import config from "../config/config";
// import {} from './common-interface'

export const addJS = (url: string, id: string): Promise<[]> => {
  return new Promise(resolve => {
    const scriptObj = document.getElementById(id);
    if (scriptObj != null) {
      resolve();
    } else {
      const scriptDom = document.createElement("script");
      scriptDom.id = id;
      scriptDom.type = "text/javascript";
      scriptDom.src = url;
      document.head.appendChild(scriptDom);
      scriptDom.onload = function() {
        resolve();
      };
    }
  });
};

export const echartsJS = () => {
  // 图表
  const url = "./common/echarts.min.js";
  return addJS(url, "echartsJS");
};

export const addQrcodeJs = () => {
  // 二维码
  const url = "./common/qrcode.min.js";
  return addJS(url, "addQrcodeJs");
};
